import React from "react";

import Stack from "../Stack";
import Button from "../OldButton";
import Box from "../Box";
import Typography from "../Typography";

interface PickerData {
  id: string | number;
  loading?: boolean;
  quantity?: number;
}

interface PropTypes {
  data: PickerData;
  add?: (id: string | number) => void;
  remove?: (id: string | number) => void;
  addIconRenderer: React.ReactNode;
  removeIconRenderer: React.ReactNode;
}

function PickerCount(props: PropTypes) {
  let { data, add, remove } = props;

  return (
    <Stack
      // direction="vertical"
      pl="m"
    >
      <Button
        bg="primary.main"
        type="circle-like"
        p="s"
        onPress={() => {
          if (add) {
            add(data.id);
          }
        }}
        disabled={data.loading || !props.add}
      >
        {props.addIconRenderer}
      </Button>
      <Box px="m">
        <Typography ff="mainBold">{data.quantity}</Typography>
      </Box>
      <Button
        bg="primary.main"
        type="circle-like"
        p="s"
        onPress={() => {
          if (remove) {
            remove(data.id);
          }
        }}
        disabled={data.loading || !props.remove}
      >
        {props.removeIconRenderer}
      </Button>
    </Stack>
  );
}

export default PickerCount;
